module.exports = __webpack_public_path__ + "img/add-white-icon.cc77e148.svg";